import { render, staticRenderFns } from "./EmailUpdateContainer.vue?vue&type=template&id=6bb0935c&scoped=true"
import script from "./EmailUpdateContainer.vue?vue&type=script&lang=js"
export * from "./EmailUpdateContainer.vue?vue&type=script&lang=js"
import style0 from "./EmailUpdateContainer.vue?vue&type=style&index=0&id=6bb0935c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb0935c",
  null
  
)

export default component.exports